<div class="glitchy" title="404">404</div>
<h2>This is not the page you are looking for !</h2>